import * as ElementPlus from 'element-plus/dist/index.full'
import zh from 'element-plus/es/locale/lang/zh-cn'
  
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ElementPlus, {
    locale: zh,
  })
})